<template>
  <div class="login-wrapper">
    <div class="login-left position-relative">
      <div class="main-side">
        <img src="../../assets/logo-kkp2.png" alt="Logo KKP" class="logo1" />
        <div></div>
        <img src="../../assets/logo-e-sea-black.png" alt="Logo E-Sea" class="logo2" />
        <h5>Sistem Pelaporan Tahunan</h5>
        <h5>Pengendalian Pemanfaatan Ruang Laut</h5>
      </div>
      <p class="position-absolute text-center w-100" style="bottom: 0px; left: 0px">
        &copy; {{ new Date().getFullYear() }} Kementerian Kelautan dan Perikanan RI.
      </p>
    </div>
    <div class="login-right">
      <div class="form-container">
        <h2 class="fw-bold">Lupa Password</h2>
        <p>Masukkan alamat email yang terdaftar untuk me-reset password</p>
        <form class="mt-4">
          <div class="form-group">
            <label class="form-label" for="email">Email</label>
            <input
              type="text"
              v-model="form.email"
              class="form-control"
              id="email"
              placeholder="Email"
              name="Email"
              v-validate="'required|email'"
            />
            <small class="text-danger" v-if="errors.has('Email')">
              {{ errors.first('Email') }}
            </small>
          </div>
          <vue-recaptcha
            @verify="markRecaptchaAsVerified"
            sitekey="6LcWcyopAAAAAMIHDH7BVEQuyt-Qw1T0C99UG6jz"
          ></vue-recaptcha>
          <strong>{{ pleaseTickRecaptchaMessage }}</strong>
          <div class="d-grid pt-3">
            <button type="button" class="btn btn-primary" @click="checkIfRecaptchaVerified" :disabled="isLoading">
              <template v-if="!isLoading">Kirim Email</template>
              <Loader v-else />
            </button>
          </div>
          <div class="text-center mt-3">
            <router-link to="/login" class="text-primary">Kembali ke halaman login</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style src="./assets/css/hope-ui.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/pro.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/custom.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/dark.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/customizer.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/rtl.min.css?v=2.0.0" lang="css" />
<!-- Library Bundle Script -->
<script src="./assets/js/core/libs.min.js"></script>
<!-- Plugin Scripts -->
<!-- <style src="./assets/css/custom/login-custom.css" lang="css" /> -->
<!-- Slider-tab Script -->
<script src="./assets/js/plugins/slider-tabs.js"></script>
<!-- Lodash Utility -->
<script src="./assets/vendor/lodash/lodash.min.js"></script>
<!-- Utilities Functions -->
<script src="./assets/js/iqonic-script/utility.js"></script>
<!-- Settings Script -->
<script src="./assets/js/iqonic-script/setting.js"></script>
<!-- Settings Init Script -->
<script src="./assets/js/setting-init.js"></script>
<!-- External Library Bundle Script -->
<script src="./assets/js/core/external.min.js"></script>
<!-- Widgetchart Script -->
<script src="./assets/js/charts/widgetcharts.js?v=2.0.0" defer></script>
<!-- Dashboard Script -->
<script src="./assets/js/charts/dashboard.js?v=2.0.0" defer></script>
<script src="./assets/js/charts/alternate-dashboard.js?v=2.0.0" defer></script>
<!-- Hopeui Script -->
<script src="./assets/js/hope-ui.js?v=2.0.0" defer></script>
<script src="./assets/js/hope-uipro.js?v=2.0.0" defer></script>
<script src="./assets/js/sidebar.js?v=2.0.0" defer></script>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { mapState, mapActions } from 'vuex'
import { Validator } from 'vee-validate'
import axios from 'axios'
import Swal from 'sweetalert2'
import Loader from '../../components/Loader/Loader'

export default {
  components: { VueRecaptcha, Loader },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      form: {
        email: '',
      },
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('auth', ['receiveToken', 'receiveLogin']),
    markRecaptchaAsVerified() {
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    async checkIfRecaptchaVerified() {
      await this.$validator.validateAll()
      if (this.$validator.errors.any()) return

      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Please tick recaptcha.'
        return true
      }
      this.resetPassword()
    },
    async resetPassword() {
      try {
        this.isLoading = true
        const res = await axios.post(`${this.baseapiPengendalian}api/auth/forgetPassword`, this.form)
        await Swal.fire('Berhasil', res.data.message, 'success')
        this.$router.push('/login')
      } catch (error) {
        if (error.status >= 500) {
          Swal.fire('Error', 'Sedang terjadi kendala pada Server', 'error')
        } else {
          Swal.fire(
            'Kirim Email Gagal',
            error.response?.data?.message || 'Terjadi kesalahan saat kirim email reset password',
            'warning',
          )
        }
      } finally {
        this.isLoading = false
      }
    },
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: () => 'Format email tidak sesuai',
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
}
</script>

<style scoped>
.login-wrapper {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.login-left {
  flex: 1;
  max-width: 700px;
  background: #ffffff;
  /* background: linear-gradient(0deg, rgba(0, 0, 84, 1) 0%, rgba(0, 212, 255, 1) 100%); */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 60px;
  box-shadow: -5px 0 25px rgba(0, 0, 0, 0.05);
  z-index: 2;
}

.main-side {
  text-align: center;
  padding-bottom: 60px;
}

.main-side .logo1 {
  height: 140px;
  object-fit: contain;
  margin-bottom: 30px;
}

.main-side .logo2 {
  height: 100px;
  object-fit: contain;
  margin-bottom: 30px;
}

.login-right {
  flex: 2;
  background: url('../../assets/login-img.jpg') no-repeat center center;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
}

.form-container {
  width: 500px;
  background: #ffffff;
  position: relative;
  z-index: 2;
  padding: 20px;
  border-radius: 5px;
}

.form-container .main-side {
  display: none;
}

.login-right::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
}

.login-left h4 {
  font-weight: 600;
  font-size: 1.8rem;
  margin-bottom: 10px;
  color: #212529;
}

.login-left p {
  color: #6c757d;
  font-size: 1rem;
  margin-bottom: 35px;
}

@media (max-width: 992px), (max-height: 700px) {
  .login-wrapper {
    display: block;
    /* justify-content: center; */
    /* align-items: center; */
    background: url('../../assets/login-img.jpg') no-repeat center center fixed;
    background-size: cover;
    height: auto;
    /* padding: 40px 20px; */
  }

  .login-left {
    /* display: none; */
    display: block;
    max-width: 100%;
    padding: 20px;
  }

  .login-right {
    /* display: block; */
    background: transparent;
    border-radius: 5px;
    width: 100%;
    margin: 100px 0px;
  }

  .login-right::after {
    display: none;
  }

  .main-side .logo1 {
    height: 70px;
    object-fit: contain;
    margin-bottom: 10px;
  }

  .main-side .logo2 {
    height: 50px;
    object-fit: contain;
  }

  .form-container .main-side {
    display: block;
  }
}
</style>
